
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Chess Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> 1 st  G.H. Raisoni Memorial Amavati International <span>FIDE Rapid Rating Chess
                Tournament
                gets inaugurated by Dr. Anil Bonde, MP, Rajyasabha.</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8 up-event-text">

                <h6 class="fw-bold">
                    <strong>25<sup>th</sup>February 2024 </strong>
                </h6>
                <p class="text-justify">1 st  G.H. Raisoni Memorial Amravati International FIDE Rapid Rating Chess Tournament
                    being organized by G.H.Raisoni Sports and Cultural Foundation &amp; Kalpana Praaksh
                    Welfare Foundation got inaugurated on 25 th  February 2024 at 10.30 hrs at the hands of
                    Dr. Anil Bonde, MP Rajyasabh and Ex-Cabinet Minister, Maharashtra State in an opening
                    ceremony held at G.H.Raisoni University, Amravati. Dr. Vinayak Deshpande, Vice
                    Chancellor of G.H.Raisoni presided over the function. Shri Prashant Awachat, Principal,
                    G.H.Raisoni College Amravati, International Arbiter Shri Sandesh Nagarnaik, Shri Pawan
                    Dodeja, Secretary, Amravati Chess Association and Shri Bhushan Shriwas, Organising
                    Secretary and Secretary of Kalpana Prakash Welfare Foundation were prominently
                    present on the occasion. Shri S.S.Soman, Member, MCA Observer Committee compered
                    the programme and also proposed vote of thanks.
                </p>
                <p class="text-justify">The tournament is recognized by Amravati Chess Association, Maharashtra Chess
                    Association (MCA), All India Chess Federation (AICF) and FIDE. G.H.Raisoni Sports and
                    Cultural Foundation and Kalpana Prakash Welfare have jointly been organizing Chess
                    Tournaments at Nagpur since last two decades. This was the First event being organized
                    at Amravati which gotg huge response as 308 entries were registered in the event
                    which included GM Sankalp Gupta, IM CRG Krishna, IM Sammed Shete, IM Arghyadip
                    Das and FM Ayush Sharma, FM Sauravh Kherdekar, FM Pawan Dodeja  and FM Akash
                    Thakur.
                </p>

            </div>
            <div class="col-lg-4 text-center">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tour2024.avif"
                    alt="swimming-competition" title="swimming-competition" class="img-fluid" />
                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/rapid-chess-championship2024.pdf"
                    target="_blank" class="cmn-button my-3"> View
                    more</a>
            </div>
            <p class="text-justify"> GM Sankalp Gupta is the Top seed of the event. Total Prizes worth Rs. 2,00,000/- are at
                stake during the chess tournament. Besides Cash Prizes, Attractive Trophies shall be
                given to top 10 players in Under-7, 9, 11, 13, 15 for Boys and Girls separately. Best
                Veteran Prize is also at stake.
            </p>
            <p class="text-justify">  The organizing Committee Team consisting of Shri Bhushan Shriwas,
                Secretary, Kalpana Prakash Welfare Foundation, Shri S.S.Soman, MCA Observer
                Committee Member, Shri Prashant awachat, Shri Nitin Bhat and Shri Amar More from
                Raisoni Group, are working hard for the success of the event under the guidance of Dr.
                Vinayak S. Deshpande Vice Chancellor, GHRU University Amravati, Shri Girish Vyas, Vice
                President MCA, and Dr. Mrinal Naik, Project Director, Raisoni Group.
                An arbiter headed by Chief Arbiter IA Sandesh Nagarnaik assisted by Deputy Chief
                Arbiter IA Ajinkya Pingle, FA Shiva iyer, FA Sonal Tambi , FA Smt Kanchana Choudhary,
                SNA Amit Tembhurne, SNA Prayas Ambade , SNA Shyam awagad , SNA Krishna
                Tarudkar , SNA Shyam Agrawal, Shri Prathamesh Machave and Shri Sagar Sakhare, Shri
                Ninad Saraf are taking care of conduction of the event. </p>
        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Day 1 Result</h4>
                            </div>
                        </div>
                    </div>
                    <iframe width="100%" height="330"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/prize_winners_amravati_mh.pdf" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>

        </div>

        <div class="border-line-sm"></div>
    </div>

</section>

<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fide-chess-amt-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fide-chess-amt-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fide-chess-amt-1.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media</h4>
                            </div>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amt_fide_rapid.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amt_fide_rapid.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amt_fide_rapid.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
